import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer id="main-footer" className="py-2">
      <div className="container footer-container">
        <div>
          <h3>Contact Us</h3>
          <ul className="list">
            <li>Phone: 027 600 2442</li>
            <li>Mobile: 027 600 2442</li>
            <li>Email: junifer@pedresflooring.co.nz</li>
            <li>Address: 131 Amesbury Drive, Churton Park, Wellington 6037</li>
          </ul>
        </div>
        <div>
          <h3>Site Links</h3>
          <ul className="list">
            <li>
              <Link to="/services/supply-install">Supply and Install</Link>
            </li>
            <li>
              <Link to="/services/supply-install">Request for Samples</Link>
            </li>
            <li>
              <Link to="/gallery">Client Reviews</Link>
            </li>
            <li>
              <Link to="/about">Our Partners</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>Follow Us</h3>
          <p>
            Check out our Facebook page for more updates on our recent projects
            and give us a like while you're at it! <br />
            <br />
            <a
              href="https://www.facebook.com/juniferpedres1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} className="icon" /> Pedres
              Flooring Ltd
            </a>
          </p>
        </div>
        <div>
          <h3>Certified</h3>
          <a
            href="https://floornz.org.nz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="images/floornz_logo.png" alt="FloorNZ Logo" />
          </a>
        </div>
        <div>
          <p>&copy; {new Date().getFullYear()}, All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
